import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useInstance } from '@/composables/useInstance';
import { I18NGetter } from '@/services/enumTranslator/I18NGetter';


export default /*#__PURE__*/_defineComponent({
  __name: 'CopyId',
  props: {
    id: null,
    prefix: { default: '' },
    hideSnackbar: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { id: number, prefix: string, hideSnackbar: boolean };

const { $clipboard } = useInstance();



const copied = ref(false);
let timeout: ReturnType<typeof setTimeout> | null = null;

const copyId = () => {
  $clipboard(props.id.toString(), !props.hideSnackbar);
  copied.value = true;

  if (timeout) {
    clearTimeout(timeout);
  }

  timeout = setTimeout(() => {
    copied.value = false;
  }, 2000);
};

return { __sfc: true,$clipboard, props, copied, timeout, copyId, I18NGetter }
}

})